import React from 'react';
import { useDispatch } from 'react-redux';

import { dashboardClienteAction } from "components/ApplicationInsights/eventNames";
import BilletSlider from "components/BilletSlider";

import boleto from 'img/menu-icon-boleto.svg';

import { IMenuItem } from '../interface';

interface IProps {
  itemComponent: React.FC<IMenuItem>,
  clickAction?: Function;
}

const Billet: React.FC<IProps> = (props: IProps) => {
  const { itemComponent, clickAction } = props;

  const dispatch = useDispatch();

  const defaultClickAction = () => {
    dispatch({
      type: 'OPEN_SLIDER',
      data: {
        title: '2ª Via de Boleto',
        subtitle:
          'Utilize os campos abaixo para localizar o seu pedido.',
        show: true,
        content: BilletSlider,
      },
    });
  };

  return React.createElement(itemComponent, {
    title: "2ª VIA",
    subtitle: "DE BOLETO",
    icon: boleto,
    trackName: dashboardClienteAction.DASHCLIENTE_SEGUNDAVIABOLETO,
    onClick: () => clickAction ? clickAction() : defaultClickAction(),
    id: "billet-menu-item"
  });
};

export default Billet;